import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { getAssetURL } from 'lib/utility/GetAssetUrl'

const UnAuthorized = () => {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      flexDirection="column"
      marginTop="4.5rem"
      alignItems="center"
      flexGrow={1}
    >
      <Box
        component="img"
        src={getAssetURL('/ErrorAssets/401.svg')}
        alt={t('common.notFoundAlt')}
        data-testid="not-found-image"
      />
      <Typography
        variant="h5"
        component="h5"
        marginTop="3rem"
        data-testid="not-found-header"
      >
        {t('common.notAuthorized')}
      </Typography>
    </Box>
  )
}

export default UnAuthorized
